import { render, staticRenderFns } from "./DeactivateTab.vue?vue&type=template&id=6e7fbb71&"
import script from "./DeactivateTab.vue?vue&type=script&lang=js&"
export * from "./DeactivateTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports